import { render, staticRenderFns } from "./rfq-view-sticky-header.vue?vue&type=template&id=4a8586c7&scoped=true"
import script from "./rfq-view-sticky-header.vue?vue&type=script&lang=js"
export * from "./rfq-view-sticky-header.vue?vue&type=script&lang=js"
import style0 from "./rfq-view-sticky-header.vue?vue&type=style&index=0&id=4a8586c7&prod&lang=css"
import style1 from "./rfq-view-sticky-header.vue?vue&type=style&index=1&id=4a8586c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8586c7",
  null
  
)

export default component.exports